import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Redirect www → non-www to consolidate SEO authority
if (window.location.hostname === 'www.gaius-tech.com') {
  window.location.replace(
    'https://gaius-tech.com' + window.location.pathname + window.location.search + window.location.hash
  );
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
